import { z, isoZ } from 'my-zod'

export const notificationTypeEnum = z.enum(['Comment', 'ChangeLog'])

export const notificationsModel = z.object({
  topic: z.string(),
  type: notificationTypeEnum,
  destinationUserId: z.number(),
  sourceProfileId: z.number(),
  operation: z.string(),
  content: z.any(),
  createdDate: isoZ.instant(),
  read: z.boolean()
})
export type notificationsModel = z.infer<typeof notificationsModel>
